<template>
    <div>
        <div v-for="pricingCondition in pricingConditions" class="px-2 py-1">
            <Price :value="pricingCondition.value"/>
            <div v-if="pricingCondition.invoicing_period" class="d-inline-block">
                / {{ __('subscriptions.invoicing.periods.' + pricingCondition.invoicing_period) }}
            </div>
            <div v-if="pricingCondition.invoicing_type" class="d-inline-block">
                / {{ __('subscriptions.invoicing.types.' + pricingCondition.invoicing_type) }}
            </div>
        </div>
        <div class="border-top border-top-dotted font-weight-bold text-muted px-2 py-1">
            <Price :value="netTotal"/>
            {{ __('general.net') }}
        </div>
        <div class="font-weight-bold text-muted px-2 py-1">
            <Price :value="taxAmount"/>
            {{ __('general.vat_with_value', {value: 19}) }}
        </div>
        <div class="border-top font-weight-bold px-2 py-1">
            <Price :value="total"/>
            {{ __('general.total') }}
        </div>
    </div>
</template>

<script>
import Price from "../Price.vue";

export default {
    components: {Price},

    props: {
        pricingConditions: Array,
        paidStoresCount: Number
    },

    computed: {
        netTotal() {
            let total = 0.0;
            for (let pricingCondition of this.pricingConditions) {
                if (pricingCondition.invoicing_type === 'per_store') {
                    total += pricingCondition.value * this.paidStoresCount;
                } else {
                    total += pricingCondition.value;
                }
            }
            return total;
        },
        taxAmount() {
            return this.netTotal * 0.19;
        },
        total() {
            return this.netTotal + this.taxAmount
        }
    }
}
</script>
